module.exports = __webpack_public_path__ + "static/media/work-5.8a1ca289.png";